import { APP_TO_BUILD } from "../../../appsConfig";
import dakotaLogo from "@/assets/logos/dakota-logo.svg";
import dakotaLogoInverse from "@/assets/logos/dakota-logo-inverse.svg";
import dakotaPlumbingLogo from "@/assets/logos/dakota-logo-plumbing.svg";
import dakotaPlumbingLogoInverse from "@/assets/logos/dakota-logo-plumbing-inverse.svg";
import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  compact?: boolean;
  iconOnly?: boolean;
  inverse?: boolean;
}

export function BrandLogo({
  className,
  compact = false,
  iconOnly = false,
  inverse = false,
}: BrandLogoProps) {
  const isPlumbing = APP_TO_BUILD === "plumbing";
  const logo = inverse
    ? isPlumbing ? dakotaPlumbingLogoInverse : dakotaLogoInverse
    : isPlumbing ? dakotaPlumbingLogo : dakotaLogo;
  const heightClass = compact ? "h-9" : "h-14";
  const widthClass = compact ? "w-[133px]" : "w-[206px]";

  return (
    <span
      aria-label="Dakota Prep"
      className={cn(
        "inline-flex shrink-0 overflow-hidden",
        heightClass,
        iconOnly ? (compact ? "w-9" : "w-14") : widthClass,
        className,
      )}
      role="img"
    >
      <img
        alt=""
        aria-hidden="true"
        className={cn("max-w-none shrink-0", heightClass, widthClass)}
        src={logo}
      />
    </span>
  );
}
